import { IS_BROWSER } from '$fresh/runtime.ts'
import { PropertyValue } from 'apps/commerce/types.ts'

interface Props {
	id: string
	contentId: string
	tabs: PropertyValue[]
	compositionText?: string
}

export default function ProductSpecificationsJs({ id, contentId, tabs, compositionText }: Props) {
	if (IS_BROWSER) {
		const $parent = document.querySelector(`#${id}`)
		const $content = $parent?.querySelector(`#${contentId}`)

		const triggers = $parent?.querySelectorAll('[data-tab-index]')
		let buttonText = ''

		triggers?.forEach((trigger, index) => {
			if (index === 0) {
				if ($content) {
					$content.innerHTML = tabs[index].value ?? ''

					const $compositionText = $content.querySelector('.composition-text')

					if ($compositionText && compositionText) {
						$compositionText.innerHTML = compositionText

						const $buttonOpen = $parent?.querySelector('.composition button')

						if (buttonText === '') buttonText = $buttonOpen?.textContent ?? ''

						$buttonOpen?.addEventListener('click', () => {
							if ($compositionText.getAttribute('data-show') === 'true') {
								$compositionText.setAttribute('data-show', 'false')
								$buttonOpen.innerHTML = buttonText
								$buttonOpen.setAttribute('data-show', 'false')
							} else {
								$compositionText.setAttribute('data-show', 'true')
								$buttonOpen.setAttribute('data-show', 'true')
								$buttonOpen.innerHTML = 'ver menos >'
							}
						})
					}
				}
			}

			trigger.addEventListener('click', () => {
				const index = Number(trigger.getAttribute('data-tab-index'))

				const $active = $parent?.querySelector('[data-tab-active=true]')
				$active?.removeAttribute('data-tab-active')

				trigger?.setAttribute('data-tab-active', 'true')

				if ($content) {
					const _content = document.createElement('div')
					_content.classList.add('product-specifications-content')
					_content.innerHTML = tabs[index].value ?? ''
					// $content.innerHTML = tabs[index].value ?? ''
					$content.innerHTML = ''
					$content.appendChild(_content)

					const $compositionText = $content.querySelector('.composition-text')

					if ($compositionText && compositionText) {
						$compositionText.innerHTML = compositionText

						const $buttonOpen = $parent?.querySelector('.composition button')

						if (buttonText === '') buttonText = $buttonOpen?.textContent ?? ''

						$buttonOpen?.addEventListener('click', () => {
							if ($compositionText.getAttribute('data-show') === 'true') {
								$compositionText.setAttribute('data-show', 'false')
								$buttonOpen.innerHTML = buttonText
								$buttonOpen.setAttribute('data-show', 'false')
							} else {
								$compositionText.setAttribute('data-show', 'true')
								$buttonOpen.setAttribute('data-show', 'true')
								$buttonOpen.innerHTML = 'ver menos >'
							}
						})
					}

					const value = tabs[index].value as string
					const shouldBtnModoDeUso = value.length > 700

					// Adiciona o botão Mostra Mais/Menos ao Modo de uso
					if (tabs[index].name === 'Modo de uso' && shouldBtnModoDeUso) {
						const $newContent = $content.querySelector(
							'.product-specifications-content',
						)

						if (!$newContent) return

						$newContent.classList.add('with-btn-modo-de-uso')

						// Botão Ver mais
						const _plusButton = document.createElement('div')
						_plusButton.classList.add('btn-modo-de-uso')
						_plusButton.classList.add('btn-plus')

						const _plusBtnContent = document.createElement('p')
						_plusBtnContent.textContent = 'ver modo de uso completo'

						_plusButton.appendChild(_plusBtnContent)

						_plusButton.addEventListener('click', () => {
							$content.classList.add('show-all-modo-de-uso')
						})

						// Botão Ver Menos
						const _minusBtn = document.createElement('div')
						_minusBtn.classList.add('btn-modo-de-uso')
						_minusBtn.classList.add('btn-minus')

						const _minusBtnContent = document.createElement('p')
						_minusBtnContent.textContent = 'fechar modo de uso'

						_minusBtn.appendChild(_minusBtnContent)

						_minusBtn.addEventListener('click', () => {
							$content.classList.remove('show-all-modo-de-uso')
							$content.scrollIntoView({ behavior: 'smooth' })
						})

						$content.insertAdjacentElement('beforeend', _plusButton)
						$content.insertAdjacentElement('beforeend', _minusBtn)
					}
				}
			})
		})
	}
	return null
}
